import { FeedItem, RawFeedItem, Subscription } from './new-internet.model';

// RTDB keys cannot contain . # $ [ ] / — derive a short, stable, safe key from
// an item's guid. djb2-style hash rendered in base36.
export function itemHash(guid: string): string {
  let hash = 5381;
  for (let i = 0; i < guid.length; i++) {
    hash = ((hash << 5) + hash + guid.charCodeAt(i)) | 0;
  }
  return 'h' + (hash >>> 0).toString(36);
}

export interface FeedGroup {
  subscription: Subscription;
  items: RawFeedItem[];
}

// Merge raw items from many feeds into one newest-first FeedItem list,
// de-duplicated by itemHash (first occurrence wins).
export function mergeFeedItems(
  groups: FeedGroup[],
  readHashes: Set<string>,
  likedHashes: Set<string>,
): FeedItem[] {
  const seen = new Set<string>();
  const out: FeedItem[] = [];
  for (const group of groups) {
    for (const item of group.items) {
      const hash = itemHash(item.guid || item.link);
      if (seen.has(hash)) { continue; }
      seen.add(hash);
      out.push({
        ...item,
        itemHash: hash,
        source: group.subscription.title,
        sourceType: group.subscription.type,
        feedUrl: group.subscription.feedUrl,
        read: readHashes.has(hash),
        liked: likedHashes.has(hash),
      });
    }
  }
  out.sort((a, b) => b.publishedAt - a.publishedAt);
  return out;
}
